import React, { createContext, useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { getCurrentUser } from '../services/authService';

// ایجاد Context برای احراز هویت
const AuthContext = createContext();

// Hook برای استفاده از AuthContext
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth باید داخل AuthProvider استفاده شود');
  }
  return context;
};

// Provider برای احراز هویت
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // بررسی توکن در localStorage
  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');

    if (token && savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('خطا در پارس کردن اطلاعات کاربر:', error);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }

    if (!token) {
      setLoading(false);
      return;
    }

    getCurrentUser()
      .then((response) => {
        const freshUser = response?.data;
        if (!freshUser) return;
        const tokenValue = localStorage.getItem('token');
        const nextUser = tokenValue ? { ...freshUser, token: tokenValue } : freshUser;
        setUser(nextUser);
        setIsAuthenticated(true);
        localStorage.setItem('user', JSON.stringify(nextUser));
      })
      .catch(() => {
        setUser(null);
        setIsAuthenticated(false);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      })
      .finally(() => setLoading(false));
  }, []);

  // ورود کاربر
  const login = (userData, token) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    toast.success('ورود موفقیت‌آمیز');
  };

  // خروج کاربر
  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    toast.success('خروج موفقیت‌آمیز');
  };

  // بروزرسانی اطلاعات کاربر
  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const value = {
    user,
    loading,
    isAuthenticated,
    login,
    logout,
    updateUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
